import React, { PropsWithChildren } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Loader } from '../Loader';

interface SearchBarProps {
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  FreeTextOnChangeHandler: (event: any) => void;
  FreeTextPlaceholder: string;
  IsLoading: boolean;
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  SearchHandler: (event: any) => void;
  ResetHandler?: () => void;
  ShowResetButton?: boolean;
  Value?: string;
}

function SearchBar(props: PropsWithChildren<SearchBarProps>) {
  const { t } = useTranslation(['common']);
  const {
    FreeTextOnChangeHandler,
    FreeTextPlaceholder,
    IsLoading,
    SearchHandler,
    ResetHandler,
    ShowResetButton = false,
    Value = '',
    children,
  } = props;

  const HandleFormSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    SearchHandler(event);
  };

  return (
    <Card className="bg-white border shadow-none p-0 mb-40">
      <Loader IsLoading={IsLoading} />
      <Form
        id="searchBarForm"
        className={IsLoading ? 'd-none' : ''}
        onSubmit={e => HandleFormSubmit(e)}
      >
        <div className="d-flex p-24">
          <Form.Control
            autoComplete="off"
            className="form-control-search flex-grow-1 ps-48 me-24"
            id="searchString"
            name="searchString"
            onChange={FreeTextOnChangeHandler}
            placeholder={FreeTextPlaceholder}
            type="text"
            value={Value ?? ''}
          />
          <Button type="submit" variant="primary">
            {t('common:buttons.search')}
          </Button>
          {ShowResetButton && ResetHandler && (
            <Button
              type="button"
              variant="outline-blue"
              onClick={ResetHandler}
              className="ms-24"
            >
              {t('common:buttons.reset')}
            </Button>
          )}
        </div>
      </Form>
      {children}
    </Card>
  );
}

export default SearchBar;
export { SearchBar };
export type { SearchBarProps };
